import { Product } from '../../types'
import {
  fetchProducts,
  fetchProduct,
  updateProduct,
  deleteProduct,
  createProduct
} from '../../services/products.service'
import createBaseStore from '../createStoreHelper'
import { actions as customActions } from './product.actions'
import { getters as customGetters } from './product.getters'
import { state as customState } from './product.state'
import { mutations as customMutations } from './product.mutations'

export const ProductModule: any = createBaseStore<Product>({
  resourceName: 'product',
  apiCalls: {
    fetchAllApiCall: fetchProducts,
    fetchByIdApiCall: fetchProduct,
    updateApiCall: updateProduct,
    deleteApiCall: deleteProduct,
    createApiCall: createProduct
  }
})

ProductModule.actions = { ...ProductModule.actions, ...customActions }
ProductModule.getters = { ...ProductModule.getters, ...customGetters }
ProductModule.state = { ...ProductModule.state, ...customState }
ProductModule.mutations = { ...ProductModule.mutations, ...customMutations }
